export var commonButtonClasses = 'inline-block text-center px-3.5 py-2.5 text-lg font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ring-offset-2 ring-2 transition-all';
